module.exports = __webpack_public_path__ + "9ffd9c8a66d629e3632ed59ba4f41b24.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/lighthouse-empty.png
// module id = 326
// module chunks = 0